import { useState } from 'react';
import { useLocation } from 'wouter';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { api } from '../lib/api';

export default function ForgotPassword() {
  const [, setLocation] = useLocation();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err: any) {
      setError(err.response?.data?.error || '发送失败,请稍后重试');
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-[#1a2e3e] flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="glass rounded-3xl p-8 text-center">
            <div className="w-20 h-20 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-400" />
            </div>
            <h2 className="text-2xl font-bold text-white mb-4">邮件已发送</h2>
            <p className="text-white/70 mb-8">
              重置密码链接已发送到 <span className="text-[#22a9d9]">{email}</span>
              <br />
              请查收邮件并按照指引重置密码
            </p>
            <button
              onClick={() => setLocation('/login')}
              className="w-full h-14 rounded-2xl bg-gradient-to-r from-[#22a9d9] to-[#6c5ce7] text-white font-medium hover:shadow-glow transition-shadow"
            >
              返回登录
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1a2e3e] flex flex-col p-6">
      {/* 返回按钮 */}
      <button
        onClick={() => setLocation('/login')}
        className="flex items-center gap-2 text-white/70 hover:text-white transition-colors mb-8"
      >
        <ArrowLeft className="w-5 h-5" />
        返回
      </button>

      {/* 主内容 */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md">
          {/* 标题 */}
          <div className="text-center mb-12">
            <div className="w-20 h-20 rounded-full bg-[#22a9d9]/20 flex items-center justify-center mx-auto mb-6">
              <Mail className="w-10 h-10 text-[#22a9d9]" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-3">忘记密码</h1>
            <p className="text-white/60">
              输入您的邮箱地址,我们将发送重置密码链接
            </p>
          </div>

          {/* 表单 */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* 邮箱输入 */}
            <div className="glass rounded-2xl p-4 flex items-center gap-3">
              <Mail className="w-5 h-5 text-white/40" />
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="邮箱地址"
                required
                className="flex-1 bg-transparent text-white placeholder-white/40 outline-none"
              />
            </div>

            {/* 错误提示 */}
            {error && (
              <div className="bg-red-500/20 border border-red-500/50 rounded-2xl p-4 text-red-300 text-sm">
                {error}
              </div>
            )}

            {/* 提交按钮 */}
            <button
              type="submit"
              disabled={loading}
              className="w-full h-14 rounded-2xl bg-gradient-to-r from-[#22a9d9] to-[#6c5ce7] text-white font-medium hover:shadow-glow transition-shadow disabled:opacity-50"
            >
              {loading ? '发送中...' : '发送重置链接'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
